import { gql } from "@grandvisionhq/graphql";
const placeOrderMutationFailurePreOrderCreationResponse = gql`
  fragment PlaceOrderMutationFailurePreOrderCreationResponseFragment on PlaceOrderMutationFailurePreOrderCreationResponse {
    failures {
      message
      code
    }
  }
`;
const placeOrderMutationFailurePostOrderCreationResponse = gql`
  fragment PlaceOrderMutationFailurePostOrderCreationResponseFragment on PlaceOrderMutationFailurePostOrderCreationResponse {
    newCheckoutId
    newCheckoutHash
    failures {
      message
      code
    }
  }
`;
const placeOrderMutationFailureRecalculatedCartResponse = gql`
  fragment placeOrderMutationFailureRecalculatedCartResponseFragment on PlaceOrderMutationFailureRecalculatedCartResponse {
    newCheckoutId
    newCheckoutHash
    failures {
      message
      code
    }
  }
`;
export {
  placeOrderMutationFailurePostOrderCreationResponse,
  placeOrderMutationFailurePreOrderCreationResponse,
  placeOrderMutationFailureRecalculatedCartResponse
};
//# sourceMappingURL=place-order-mutation-failure.js.map
